import View from './View';

class ShowView extends View {
    constructor(name) {
        super(name);
        this._type = 'ShowView';
    }
}

export default ShowView;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/View/ShowView.js
 **/